import { Button, Select, TableProps } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "../../../../assets/icons/AddIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CustomTable from "../../../../components/ui/CustomTable";

import { useKeycloak } from "@react-keycloak/web";
import { useAppSelector } from "../../../../app/store";
import EditIcon from "../../../../assets/icons/EditIcon";
import { useGetAllCompanyQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import {
  useGetAllProductQuery,
  useGetAllWorkFlowQuery,
} from "../../../../features/portal/Products/productsApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import {
  GetAllWorkFlowDataParamsType,
  GetAllWorkFlowDataType,
} from "../../../../types/portal/product";
import { countParPageSerialNumber } from "../../../../utils/number";

export default function ApprovalDaynamicList() {
  const { keycloak } = useKeycloak();
  const { user } = useAppSelector((state) => state.auth);
  const isAdmin2 = keycloak?.realmAccess?.roles?.includes("admin2");
  const [selectedCompany, setSelectedCompany] = useState<number | undefined>(
    undefined
  );

  const [switchStatus, setSwitchStatus] = useState(false);
  // const { isError, error, isLoading, data } = useGetAllWorkFlowQuery(
  //   filter?.companyId
  //     ? {
  //         params: {
  //           ...filter,
  //           skip: undefined,
  //           search: keyword,
  //           page,
  //         },
  //       }
  //     : skipToken
  // );

  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetAllWorkFlowDataParamsType>({
    defaultFilter: {
      companyId: user?.data?.company_id,
    },
  });

  const {
    isError: companyIsError,
    error: companyError,
    data: companyData,
  } = useGetAllCompanyQuery({
    params: {
      company_id: isAdmin2 ? user?.data?.company_id : undefined,
      page: 1,
      limit: 1000000000000,
    },
  });

  const { isError, error, isLoading, data } = useGetAllWorkFlowQuery(
    {
      params: {
        ...filter,
        skip: undefined,
        search: keyword,
        page,
      },
    },
    {
      skip: !filter?.id,
    }
  );

  // console.log("data", data);

  const {
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      page: 1,
      limit: 1000000000000,
    },
  });
  useError(isError, error, "Get all workflow fail");
  useError(isAllProductError, allProductError, "Get all product fail");
  useError(companyIsError, companyError, "Get all company fail");

  const allProduct = getAllProduct?.data?.data;

  // useEffect(() => {
  //   const products = getAllProduct?.data?.data;
  //   // if (!filter?.id && Array.isArray(products) && products.length > 0) {
  //   //   handleFilter("id", products[0].id);
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getAllProduct, filter?.id]);

  // useEffect(() => {
  //   if (companyData?.data?.length && selectedCompany === undefined) {
  //     setSelectedCompany(companyData.data[0].id);
  //     handleFilter("companyId", companyData.data[0].id); // <-- Add this line
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [companyData, selectedCompany]);

  const columns: TableProps<GetAllWorkFlowDataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Company Name",
      dataIndex: "company",
      render: (val) => (val ? val?.company_name : "N/A"),
    },

    {
      title: "Project Name",
      dataIndex: "project",
      render: (val) => (val ? val?.name : "N/A"),
    },

    {
      title: "Role Name",
      dataIndex: "role",
      render: (val) => (val ? val?.roleName : "N/A"),
    },
    {
      title: "Pool A Number",
      dataIndex: "poolANumber",
      align: "center",
      render: (val) => (val ? val : "0"),
    },
    {
      title: "Pool B Number",
      dataIndex: "poolBNumber",
      align: "center",
      render: (val) => (val ? val : "0"),
    },

    {
      title: "Amount From",
      dataIndex: "amountFrom",
      render: (val) => (val ? val : "0"),
    },
    {
      title: "Amount To",
      dataIndex: "amountTo",
      render: (val) => (val ? val : "0"),
    },

    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Link to={`/admin/users-roll-access/approval-dynamic-edit/${val}`}>
            <Button
              className="action-button"
              size="small"
              icon={<EditIcon />}
            />
          </Link>

          {/* <Button className="action-button" size="small" icon={<ViewIcon />} /> */}
        </div>
      ),
    },
  ];

  return (
    <>
      <SidebarLayout title={`Approval Dynamic List`}>
        <CustomTable
          loading={isLoading}
          limit={limit}
          page={page}
          columns={columns}
          total={data?.data?.total} // Update total as per the data
          dataSource={data?.data?.data}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              {/* <Input
                suffix={<SearchIcon />}
                placeholder="Search"
                style={{ width: 220 }}
              /> */}

              {/* <Select
                allowClear
                showSearch
                placeholder="Status"
                filterOption={selectSearchOption}
                options={selectStringOption(["Active", "Inactive"])}
                className="min-w-[90px]"
                suffixIcon={<SelectDownIcon />}
                rootClassName="icon-gray"
              /> */}

              {/* <Select
                placeholder="Select Company"
                options={
                  companyData?.data?.map((company: any) => ({
                    label: company?.company_name,
                    value: company?.id,
                  })) || []
                }
                // value={selectedCompany}
                onChange={(value) => {
                  // setSelectedCompany(value);
                  handleFilter("companyId", value);
                }}
                value={filter?.companyId ?? undefined}
                className="w-full"
                suffixIcon={<SelectDownIcon />}
                style={{ width: "100%" }}
                disabled={isAdmin2}
              /> */}

              <Select
                placeholder="Company Name"
                showSearch
                options={
                  companyData?.data?.companies?.map((company: any) => ({
                    label: company?.company_name,
                    value: company?.id,
                  })) || []
                }
                value={filter?.companyId ?? undefined}
                onChange={(value) => handleFilter("companyId", value)}
                className="min-w-[150px] w-full max-w-full"
                suffixIcon={<SelectDownIcon />}
                // style={{ width: "100%" }}
                allowClear
                disabled={isAdmin2}
                optionFilterProp="label"
              />

              <Select
                placeholder="Select Project"
                showSearch
                options={
                  allProduct?.map((project: any) => ({
                    label: project?.name,
                    value: project?.id,
                  })) || []
                }
                value={filter?.id ?? undefined}
                onChange={(value) => handleFilter("id", value)}
                className="w-full"
                suffixIcon={<SelectDownIcon />}
                style={{ width: "250px" }}
                allowClear
                optionFilterProp="label"
              />

              <Link to="/admin/users-roll-access/approval-dynamic-add">
                <Button
                  type="primary"
                  className="middle-button"
                  icon={<AddIcon />}
                >
                  Add Approval
                </Button>
              </Link>
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}

interface DataType {
  groupName: string;
  groupRoleName: string;
  date: string;
  status: string;
  id: string;
}

const datas: DataType[] = [
  {
    groupName: "Admin",
    groupRoleName: "Business Admin",
    date: "10 Jan, 2025",
    status: "Active",
    id: "1",
  },
  {
    groupName: "Admin",
    groupRoleName: "Business Admin",
    date: "10 Jan, 2025",
    status: "Active",
    id: "2",
  },
  {
    groupName: "Admin",
    groupRoleName: "Business Admin",
    date: "10 Jan, 2025",
    status: "Active",
    id: "3",
  },
];
